import { HStack } from 'native-base';
import React, { ReactNode } from 'react';

import ReservationDetailDate from 'app/components/ReservationSummary/ReservationDetailDate';
import ReservationDetailOption from 'app/components/ReservationSummary/ReservationDetailOption';
import ReservationDetailTime from 'app/components/ReservationSummary/ReservationDetailTime';
import ReservationDetailTravelParty from 'app/components/ReservationSummary/ReservationDetailTravelParty';
import {
  EntitlementReservation,
  Pass,
  ReservationOption,
  ReservationType,
} from 'app/services/GuestCenterService.types';
import { ReservationTextHelper } from 'app/services/I18n';

export type ReservationDetailsProps = {
  children?: ReactNode;
  reservation: EntitlementReservation;
  passes: Pass[];
  rt: ReservationTextHelper;
  option?: ReservationOption;
  showOption?: boolean;
  showTime?: boolean;
};

export default function ReservationDetails({
  reservation,
  passes,
  showOption,
  showTime = true,
  option,
  rt,
}: ReservationDetailsProps) {
  const flexBasis = showOption ? '25%' : '33%';

  return (
    <HStack justifyContent="space-evenly" testID="ReservationDetails" w="full">
      <ReservationDetailTravelParty flexBasis={flexBasis} passes={passes} />
      {showOption && option && (
        <ReservationDetailOption flexBasis={flexBasis} option={option} rt={rt} />
      )}
      <ReservationDetailDate dateTime={reservation.reservationDateTime} flexBasis={flexBasis} />
      {showTime && reservation.type === ReservationType.Time && (
        <ReservationDetailTime
          dateTime={reservation.reservationDateTime}
          flexBasis={flexBasis}
          ianaTimezone={reservation.attractionConfig?.ianaTimezone}
        />
      )}
    </HStack>
  );
}
